import moment from "moment";

export function getStatoScadenzaAccertamento(
  scadenza,
  oggi = moment(),
  giorniPreavviso = 90,
) {
  if (scadenza === null || scadenza === undefined || scadenza === "") {
    return { colore: "#40C18F", testo: "Nessuna scadenza", filtro: "verde" };
  }

  const dataScadenza = moment(scadenza, ["YYYY-MM-DD", moment.ISO_8601], true);
  if (!dataScadenza.isValid()) {
    return { colore: "#40C18F", testo: "Nessuna scadenza", filtro: "verde" };
  }

  const dataOggi = moment(oggi).startOf("day");
  if (dataScadenza.isBefore(dataOggi, "day")) {
    return {
      colore: "#FF2768",
      testo: `Scaduto il ${dataScadenza.format("DD/MM/YYYY")}`,
      filtro: "rosso",
    };
  }

  if (
    dataScadenza.isBefore(dataOggi.clone().add(giorniPreavviso, "days"), "day")
  ) {
    return {
      colore: "#FFC897",
      testo: `In scadenza il ${dataScadenza.format("DD/MM/YYYY")}`,
      filtro: "arancione",
    };
  }

  return {
    colore: "#40C18F",
    testo: `Scadrà il ${dataScadenza.format("DD/MM/YYYY")}`,
    filtro: "verde",
  };
}
